import Cookies from 'js-cookie';
import { BreadcrumbJsonLd, FAQPageJsonLd, NextSeo } from 'next-seo';
import { useEffect, useMemo, useRef, useState } from 'react';
import { getSeoVisibility } from '../../../src/appconfig';
import NewFooter from '../../../src/components/HomePage/NewFooter';
import NewHeader from '../../../src/components/HomePage/NewHeader';
// import MoeSoftAsk from "../../../src/components/MoeSoftAsk";
import Head from 'next/head';
import { useRouter } from 'next/router';
import {
  b2G1_recover_key,
  recoveryDataKey,
} from '../../../src/Constants/AddressPage';
import { prefetchAndOpenCart } from '../../../src/Utils/CartUtils';
import { getUserIsLoggedIn } from '../../../src/Utils/helper';
import { MainContainer } from '../../../src/components/Product/PdpHeader/styled';
import { LocalSimilarSection } from '../../../src/components/Product/RatingandReviews/styled';
import LocalSimilarProducts from '../../../src/components/Product/SimilarProducts/LocalSimilarProducts';
import Breadcrumbs from '../../../src/components/StoreCategoryPage/Breadcrumbs';
import CategoryBanner from '../../../src/components/StoreCategoryPage/CategoryBanner';
import CategoryHead from '../../../src/components/StoreCategoryPage/CategoryHead';
import L2CategoryScroll from '../../../src/components/StoreCategoryPage/L2Category/L2CategoryScroll';
import StickyCategoryGridCover from '../../../src/components/StoreCategoryPage/StickyCategoryGridCover';
import {
  getSeoData,
  showNewCategoryUI,
  useGetCategoriesData,
} from '../../../src/components/StoreCategoryPage/common';
import { fireGeneralScreenEvent } from '../../../src/components/StoreCategoryPage/instrumentation';
import { getBreadCrumbsJSONldData } from '../../../src/datafetchers/CategoryPage';
import GlobalStyle from '../../../src/styles/globalStylesV2';
import { noIndexCategoyIds } from './common';
import { fireEventForRepeatUser } from '../../Utils/useFirebase';
import OfferStripHeader from '../ArticlePage/OfferStripHeader';
import CategoryHeadElement from '../StoreCategoryPage/CategoryHeadElement';

export default function CategoryPage(props) {
  const {
    categoryStaticData,
    categoryNavBarData,
    webUrl,
    subCategoriesData,
    breadCrumbsData,
    showNewUI,
    categoryId,
    userType,
    experimentPage,
    keywords,
  } = props;
  const [showPrice, setShowPrice] = useState(false);
  const [addedToCart, setAddedToCart] = useState(false);
  const bottomRef = useRef();
  const [changeData, setChangeData] = useState(false);
  const markNoIndex = noIndexCategoyIds.includes(categoryId);
  const router = useRouter();
  const { categoryData } = useGetCategoriesData(
    categoryStaticData,
    webUrl,
    setShowPrice,
    showNewUI,
    categoryId,
    experimentPage,
  );
  const { items } = categoryData?.data;
  const memoisedItems = useMemo(() => {
    const bannerData = [];
    const tabsData = [];
    const stripData = [];
    items?.forEach((item, index) => {
      switch (item.itemType) {
        case 'BANNER':
          bannerData.push(item);
          break;
        case 'MULTIPLE_ITEMS':
          tabsData.push(item);
          break;
        case 'MARQUEE_STRIP':
          stripData.push(item);
        default:
          tabsData.push(item);
      }
    });

    return {
      tabsData,
      bannerData,
      stripData,
    };
  }, [categoryData]);

  const { tabsData, bannerData, stripData } = memoisedItems;
  const { sectionBgImageDesktop, sectionBgImageMobileWeb, sectionBgImage } =
    categoryData?.data;
  let category_banner_data = [
    {
      mobileWebImage: sectionBgImageMobileWeb || sectionBgImage,
      desktopImage: sectionBgImageDesktop,
    },
  ];
  const { metaTitle, metaDescription, openGraphData } = getSeoData(
    categoryData,
    webUrl,
    tabsData?.[0]?.items[0],
  );
  const categoryName = categoryData?.data?.tabName;
  const faqsData = categoryData?.data?.footNoteFaqs || categoryData?.data?.faqs;
  const alsoSearchFor = categoryData?.data?.alsoSearchFor;
  const newUI = showNewCategoryUI(true, categoryId);

  const footnoteData = newUI
    ? items?.filter(function (item) {
        return item?.itemType === 'SEO_FOOTNOTE';
      })
    : categoryData?.data?.footnote;

  const heading = newUI ? footnoteData?.[0]?.heading : categoryName;
  const htmlText = newUI ? footnoteData?.[0]?.htmlText : footnoteData;
  const priceTable = newUI
    ? footnoteData?.[0]?.priceTable
    : categoryData?.data?.priceTable;
  const ratingTable = newUI
    ? footnoteData?.[0]?.reviewTable
    : categoryData?.data?.reviewTable;
  const updatedOn = newUI
    ? footnoteData?.[0]?.lastUpdatedAtDate
    : categoryData?.data?.lastUpdatedAtDate;
  const catWebUrl = categoryData?.data?.webUrl || `/category/${webUrl}`;

  useEffect(() => {
    setAddedToCart(false);
  }, [addedToCart]);

  useEffect(() => {
    if (Cookies.get('offer_strip_data')) {
      setChangeData(JSON.parse(Cookies.get('offer_strip_data')));
    }
  }, []);

  const recoverDataFlow = async () => {
    const sku_ids = router.query[b2G1_recover_key];
    if (sku_ids && !Cookies.get(recoveryDataKey)) {
      Cookies.set('cart_items', sku_ids);
      prefetchAndOpenCart();
    }
  };
  useEffect(() => {
    if (!getUserIsLoggedIn()) recoverDataFlow();
  }, [router.query.sku_ids]);
  const findCategory = () => {
    let tabName = '';
    subCategoriesData?.map((element) => {
      if (element?._id === categoryId) {
        tabName = element?.tabName;
      } else {
        element?.subCategories?.map((subCategories, index) => {
          if (subCategories?._id === categoryId) {
            tabName = element?.tabName;
          }
        });
      }
    });
    return tabName;
  };
  useEffect(() => {
    fireGeneralScreenEvent(webUrl, categoryData?.data?.tabName, findCategory());
    fireEventForRepeatUser('category_page');
  }, [categoryId]);
  useEffect(() => {
    const insTags = document.querySelectorAll('ins');

    // Remove each <ins> element
    insTags?.forEach((ins) => ins?.remove());
    const googleAd = document.querySelector('#google-anno-sa');
    googleAd?.remove();
  }, []);
  return (
    <>
      {getSeoVisibility() ? (
        <>
          <NextSeo
            title={metaTitle}
            description={metaDescription}
            openGraph={openGraphData}
            noindex={markNoIndex ? true : false}
            nofollow={markNoIndex ? true : false}
          />
          {faqsData?.length > 0 && <FAQPageJsonLd mainEntity={faqsData} />}
          {breadCrumbsData?.length > 0 && (
            <BreadcrumbJsonLd
              itemListElements={getBreadCrumbsJSONldData(breadCrumbsData)}
            />
          )}
          {keywords ? (
            <Head>
              <meta name={'keywords'} content={keywords} />
            </Head>
          ) : null}
        </>
      ) : null}
      <CategoryHeadElement
        categoryId={categoryId}
        categoryData={categoryData?.data}
      />
      <CategoryHead
        categoryDataInfo={catWebUrl}
        tabsData={tabsData}
        categoryId={categoryId}
        experimentPage={experimentPage}
      />
      <GlobalStyle />
      <NewHeader
        showOldSubHeader={true}
        categoryData={categoryNavBarData}
        addedToCart={addedToCart}
        showCart={true}
        showTrackOrder={true}
        setAddedToCart={setAddedToCart}
        location={'category'}
      />
      <OfferStripHeader pdp={true} sticky={true} />
      <MainContainer paddingTop="190px" categ subCategory fullWidth>
        {breadCrumbsData?.length ? (
          <Breadcrumbs breadCrumbs={breadCrumbsData} addClass={true} />
        ) : null}

        {!showNewCategoryUI(showNewUI, categoryId) && (
          <CategoryBanner
            bannerData={category_banner_data}
            category_name={categoryName}
          />
        )}
        <L2CategoryScroll
          categoryId={categoryId}
          subCategoriesData={subCategoriesData}
        />
      </MainContainer>
      <StickyCategoryGridCover
        categoryData={categoryData}
        categoryId={categoryId}
        subCategoriesData={subCategoriesData}
        tabsData={tabsData}
        categoryNavBarData={categoryNavBarData}
        categoryName={categoryName}
        setAddedToCart={setAddedToCart}
        showPrice={showPrice}
        showNewUI={showNewUI}
        bannerData={category_banner_data}
        bottomRef={bottomRef}
        userType={userType}
      />
      <LocalSimilarSection withCategories={subCategoriesData.length > 0}>
        <LocalSimilarProducts
          productId={categoryId}
          setChangeCartCount={setAddedToCart}
        />
      </LocalSimilarSection>
      <NewFooter
        heading={heading}
        content={htmlText}
        webUrl={webUrl}
        faqsData={experimentPage ? [] : faqsData}
        priceTable={priceTable}
        alsoSearchFor={alsoSearchFor}
        bottomRef={bottomRef}
        ratingTable={ratingTable}
        updatedOn={updatedOn}
      />
    </>
  );
}
